/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PlanVariant {
  PRE_20250729 = 'pre_20250729',
  _20250729 = '20250729',
  _20250917 = '20250917',
  _20251102 = '20251102',
  _20260224 = '20260224',
}
